import './styles.scss';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import {} from 'src/validations';
import { IAppState } from 'src/store';
import { Toastify } from 'src/services';
import { Input, View, Button, Text, Select } from 'src/components/common';
import './styles.scss';
import Form from 'src/components/common/Form';
import { Modal } from 'src/components/Modal';
import { validationSchema } from 'src/containers/ManageUsers/NewUser/constant';
import { User } from '../type';
import { usersActions } from 'src/redux/usersRedux';
import InputPhone from 'src/components/common/InputPhone';

type UserFormValue = {
  firstName: string;
  lastName: string;
  email: string;
  mobile: string;
  role: string;
  companyOrLawFirm: string;
};

const NewUser: React.FC<Props> = ({ user, userRoles, onClose, onCreateUser, onUpdateUser }) => {
  const isCreate = !user;
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const getInitialData = () => {
    const initialValue: UserFormValue = {
      firstName: isCreate ? '' : user?.firstName ?? '',
      lastName: isCreate ? '' : user?.lastName ?? '',
      email: isCreate ? '' : user?.email ?? '',
      mobile: isCreate ? '' : user?.mobile ?? '',
      role: isCreate ? '' : user?.role ?? '',
      companyOrLawFirm: isCreate ? '' : user?.companyOrLawFirm ?? '',
    };
    return initialValue;
  };
  const handleSubmitForm = (data: UserFormValue) => {
    setIsSubmitting(true);
    if (isCreate) {
      onCreateUser(
        data,
        res => {
          Toastify.success('New user has been created successfully!');
          onClose(res);
        },
        actionFailed,
      );
    } else {
      if (user) {
        onUpdateUser(
          { id: user.id, body: data },
          res => {
            Toastify.success('This user has been updated successfully!');
            onClose(res);
          },
          actionFailed,
        );
      }
    }
  };

  const actionFailed = (err: any) => {
    setIsSubmitting(false);
    Toastify.error(err?.message);
  };
  const userRolesOption = userRoles.map(t => ({
    value: t.key,
    label: t.name,
  }));

  return (
    <Modal onModalClosed={onClose}>
      <Text variant="title" className="mb-16" size={20}>
        {isCreate ? 'Create a New User' : 'Update User'}
      </Text>
      <View className="ctn-new-deposition">
        <Formik initialValues={getInitialData()} onSubmit={handleSubmitForm} validationSchema={validationSchema}>
          {({ values, errors, touched, getFieldProps, handleSubmit, setValues, handleBlur }) => {
            return (
              <Form onSubmit={handleSubmit} autoComplete="off" className="ctn-new-deposition__form">
                <Input
                  label="First Name *"
                  placeholder="First Name"
                  containerClassName="mb-16"
                  {...getFieldProps('firstName')}
                  errorMessage={touched.firstName ? errors.firstName : ''}
                />

                <Input
                  label="Last Name *"
                  placeholder="Last Name"
                  errorMessage={touched.lastName ? errors.lastName : ''}
                  containerClassName="mb-16 "
                  {...getFieldProps('lastName')}
                />
                <Input
                  label="Email *"
                  placeholder="Email"
                  containerClassName="mb-16 "
                  errorMessage={touched.email ? errors.email : ''}
                  disabled={!isCreate}
                  {...getFieldProps('email')}
                />
                <InputPhone
                  label="Phone Number *"
                  placeholder="Phone Number"
                  errorMessage={touched.mobile ? errors.mobile : ''}
                  containerClassName="mb-16"
                  {...getFieldProps('mobile')}
                  onChange={(value: string) => setValues({ ...values, mobile: value })}
                />
                <Select
                  containerClassName="mb-16"
                  label="User Role *"
                  options={userRolesOption}
                  onChange={(value: any) => {
                    setValues({ ...values, role: value });
                  }}
                  value={values.role}
                  errorMessage={touched.role ? errors.role : ''}
                />
                <Input
                  label="Company/Law Firm *"
                  placeholder="Company/Law Firm"
                  containerClassName="mb-16"
                  {...getFieldProps('companyOrLawFirm')}
                  errorMessage={touched.companyOrLawFirm ? errors.companyOrLawFirm : ''}
                />
                <View isRow justify="center" className="mt-24">
                  <Button variant="secondary-outline" type="button" className="mr-20" onClick={() => onClose()}>
                    CANCEL
                  </Button>
                  <Button type="submit" variant="secondary" isLoading={isSubmitting}>
                    {isCreate ? 'CREATE' : 'UPDATE'}
                  </Button>
                </View>
              </Form>
            );
          }}
        </Formik>
      </View>
    </Modal>
  );
};

type Props = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps & {
    user?: User | null;
    onClose: (...args: any[]) => void;
  };
const mapStateToProps = (state: IAppState) => ({
  userTypes: state.content.userTypes,
  userRoles: state.content.userRoles,
});

const mapDispatchToProps = {
  onCreateUser: usersActions.createUser,
  onUpdateUser: usersActions.updateUser,
};
export default connect(mapStateToProps, mapDispatchToProps)(NewUser);
